// @flow
import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import routerActions from '../../actions/router';
import NoResultsBanner from '../NoResultsBanner/NoResultsBanner';

import type {Node} from 'react';

type DispatchProps = {
    openDateRangePicker: () => typeof routerActions.pushModal
};

type Props = DispatchProps;

export function NoResultsBannerWithDatepickerButton(props: Props) {
    const buttonHandler = () => {
        props.openDateRangePicker();
    };
    const title = (
        <FormattedMessage
            id="seeOtherProperties"
            description="See other properties title"
            defaultMessage="See other properties"
        >
            {(message: Node): Node => message}
        </FormattedMessage>
    );
    const description = (
        <FormattedMessage
            id="propertyTypesForCheckInTomorrow"
            description="Property types for check in tomorrow description"
            defaultMessage="More property types are available for check-in tomorrow"
        >
            {(message: Node): Node => message}
        </FormattedMessage>
    );
    const buttonLabel = (
        <FormattedMessage
            id="changeDates"
            description="Change dates button label"
            defaultMessage="Change dates"
        />
    );

    return (
        <NoResultsBanner
            title={title}
            description={description}
            buttonLabel={buttonLabel}
            buttonHandler={buttonHandler}
        />
    );
}

const mapDispatchToProps = {
    openDateRangePicker: () => routerActions.pushModal('DATES')
};

export default connect(
    null,
    mapDispatchToProps
)(NoResultsBannerWithDatepickerButton);
